import React from "react";
import { Row, Col, Card, Form, Input, Button, Typography, Space } from "antd";
import {
  CheckCircleOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons";

const { Title, Paragraph } = Typography;

const ValidateIncentiveCode: React.FC = () => {
  const [form] = Form.useForm();

  const onFinish = (values: any) => {
    console.log("Success:", values);
    // Handle form submission here
  };

  const onFinishFailed = (errorInfo: any) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <div className="validate-incentive-page">
      <Row gutter={[0, 30]} style={{ maxWidth: "100%", margin: "0 auto" }}>
        {/* Header Card */}
        <Col span={24}>
          <Card
            style={{
              borderRadius: "10px",
              boxShadow: "0px 2px 4px 0px rgba(0, 0, 0, 0.20)",
              overflow: "hidden",
              marginBottom: "30px",
            }}
            bodyStyle={{ padding: 0 }}
          >
            <Row gutter={0}>
              <Col xs={24} lg={13}>
                <div
                  style={{
                    padding: "42px",
                    paddingRight: "20px",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    minHeight: "280px",
                  }}
                >
                  <Space
                    direction="vertical"
                    size={20}
                    style={{ width: "100%" }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "20px",
                      }}
                    >
                      <CheckCircleOutlined
                        style={{
                          fontSize: "36px",
                          color: "#4D4D4D",
                          flexShrink: 0,
                        }}
                      />
                      <Title
                        level={2}
                        style={{
                          margin: 0,
                          color: "#4D4D4D",
                          fontFamily:
                            "Open Sans, -apple-system, Roboto, Helvetica, sans-serif",
                          fontSize: "24px",
                          fontWeight: "700",
                          letterSpacing: "0.5px",
                          lineHeight: "1",
                          flex: 1,
                        }}
                      >
                        Validate Incentive Code
                      </Title>
                    </div>
                    <Paragraph
                      style={{
                        color: "#4D4D4D",
                        fontSize: "18px",
                        fontWeight: "400",
                        lineHeight: "24px",
                        margin: 0,
                        fontFamily:
                          "Open Sans, -apple-system, Roboto, Helvetica, sans-serif",
                        letterSpacing: "0.5px",
                      }}
                    >
                      Validating an Incentive Code will place the code in a
                      'Sale In Progress' status until a Reimbursement Request is
                      submitted or the sale is canceled.
                      <br />
                      <span style={{ fontWeight: 700 }}>
                        You must submit a Reimbursement Request within 4 weeks
                        or the transaction will be canceled automatically
                      </span>{" "}
                      so that the Incentive Code may be redeemed at a later
                      date.
                    </Paragraph>
                  </Space>
                </div>
              </Col>
              <Col xs={24} lg={11}>
                <div
                  style={{
                    height: "100%",
                    minHeight: "280px",
                    backgroundImage: "url(/images/validate-hero.webp)",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    borderRadius: "0px 10px 10px 0px",
                  }}
                />
              </Col>
            </Row>
          </Card>
        </Col>

        {/* Form Card */}
        <Col span={24}>
          <Card
            className="validate-form-card"
            style={{
              borderRadius: "10px",
              boxShadow: "0px 2px 4px 0px rgba(0, 0, 0, 0.20)",
              maxWidth: "764px",
              margin: "0",
            }}
            bodyStyle={{
              padding: "83px 80px",
            }}
          >
            <Form
              form={form}
              name="validateIncentiveCode"
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              layout="vertical"
              requiredMark={false}
            >
              <Row gutter={[20, 0]} align="bottom">
                <Col xs={24} sm={14}>
                  <Form.Item
                    label={
                      <span
                        style={{
                          color: "#4D4D4D",
                          fontFamily:
                            "Open Sans, -apple-system, Roboto, Helvetica, sans-serif",
                          fontSize: "16px",
                          fontWeight: "400",
                          lineHeight: "1",
                        }}
                      >
                        Customer Incentive Code
                      </span>
                    }
                    name="incentiveCode"
                    rules={[
                      {
                        required: true,
                        message: "Please input the customer incentive code!",
                      },
                    ]}
                    style={{ marginBottom: 0 }}
                  >
                    <Input
                      placeholder="Customer Incentive Code"
                      style={{
                        borderRadius: "6px",
                        border: "1px solid #CCC",
                        backgroundColor: "#FFF",
                        padding: "10px",
                        fontSize: "16px",
                        fontFamily:
                          "Open Sans, -apple-system, Roboto, Helvetica, sans-serif",
                        height: "42px",
                      }}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={10}>
                  <Form.Item style={{ marginBottom: 0, marginTop: "22px" }}>
                    <Button
                      type="primary"
                      htmlType="submit"
                      style={{
                        backgroundColor: "#DF701F",
                        borderColor: "#DF701F",
                        borderRadius: "6px",
                        height: "42px",
                        width: "100%",
                        fontSize: "16px",
                        fontWeight: "400",
                        fontFamily:
                          "Open Sans, -apple-system, Roboto, Helvetica, sans-serif",
                        lineHeight: "1",
                        border: "none",
                      }}
                      size="large"
                    >
                      View Customer Information
                    </Button>
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col span={24}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                      marginTop: "6px",
                      marginLeft: "0px",
                    }}
                  >
                    <ExclamationCircleOutlined
                      style={{
                        fontSize: "18px",
                        color: "#777",
                      }}
                    />
                    <span
                      style={{
                        color: "#777",
                        fontSize: "16px",
                        fontFamily:
                          "Open Sans, -apple-system, Roboto, Helvetica, sans-serif",
                        fontWeight: "400",
                        lineHeight: "1",
                      }}
                    >
                      Incentive codes are case sensitive!
                    </span>
                  </div>
                </Col>
              </Row>
            </Form>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default ValidateIncentiveCode;
